import TermsOfUse from './TermsOfUse.jsx';

export {
  TermsOfUse
}


// WEBPACK FOOTER //
// ./components/partials/terms-of-use/index.js